import { Storage } from 'aws-amplify';

export const postImageBlobToS3 = (
  key: string,
  blob: any,
  contentType: string
): ReturnType<typeof Storage.put> =>
  Storage.put(key, blob, {
    contentType,
  });
